import classNames from 'classnames';
import classes from './VerticalStack.module.scss';

function VerticalStack({ children, space, mobileSpace, addBottomPadding, className, style }) {
    return (
        <div
            style={{
                '--vs-vertical-space': `${space ?? 30}px`,
                '--vs-vertical-space-mobile': `${mobileSpace ?? space ?? 20}px`, // Fallback to space if mobileSpace is not provided
                ...style,
            }}
            className={classNames(
                classes.verticalStack,
                addBottomPadding && classes.bottomPadding,
                className
            )}
        >
            {children}
        </div>
    );
}
export default VerticalStack;
